import { Component, OnInit } from '@angular/core';
@Component({
	selector: 'app-page-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],

})
export class HomePageComponent  {}
